module.exports = __webpack_public_path__ + "0bfecefb55feb9283a5dac3f925c5664.png";